var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.serviceAccountCreated
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Email" } }, [_vm._v("Email:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "email",
                  placeholder: "Email address for service account",
                },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.email = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v(
                  "This email will be used to identify the service account."
                ),
              ]),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Email", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "DisplayName" } }, [
                _vm._v("Display name:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.displayName,
                    expression: "displayName",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Display name for service account",
                },
                domProps: { value: _vm.displayName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.displayName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v(
                  'A descriptive name for this service account (e.g., "CI/CD Pipeline", "Data Sync Service").'
                ),
              ]),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "DisplayName", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "Description" } }, [
              _vm._v("Description (optional):"),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.description,
                  expression: "description",
                },
              ],
              staticClass: "form-control",
              attrs: {
                rows: "3",
                placeholder: "Purpose of this service account",
              },
              domProps: { value: _vm.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.description = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "form-text text-muted" }, [
              _vm._v("Describe what this service account will be used for."),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInitial || _vm.statusInvalid,
                  expression: "statusInitial || statusInvalid",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button" },
              on: { click: _vm.handleCreateServiceUserCommandV1 },
            },
            [_vm._v("Create Service Account")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInvoking,
                  expression: "statusInvoking",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button", disabled: "" },
            },
            [_vm._v("Creating...")]
          ),
        ])
      : _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "alert alert-success", attrs: { role: "alert" } },
            [
              _c("h4", { staticClass: "alert-heading" }, [
                _vm._v("Service Account Created!"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Service account "),
                _c("strong", [_vm._v(_vm._s(_vm.email))]),
                _vm._v(" was created successfully."),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("h4", { staticClass: "fg-color-blue" }, [_vm._v("Next steps:")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/users/manage/type/${_vm.email}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-key",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Generate API keys")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            { staticClass: "fg-color-blue", staticStyle: { margin: "20px 0" } },
            [_vm._v("or")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/users/service-accounts/${_vm.tid}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-list",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("View all service accounts")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            { staticClass: "fg-color-blue", staticStyle: { margin: "20px 0" } },
            [_vm._v("or")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              on: { click: _vm.handleFinish },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Create another service account")]),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Create a Service Account")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "Service accounts are used for API access and automation. They use API keys or tokens for authentication, not passwords."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "alert alert-info", attrs: { role: "alert" } },
      [
        _c("i", {
          staticClass: "fa fa-info-circle",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("strong", [_vm._v("Note:")]),
        _vm._v(
          " Service accounts cannot sign in through the web UI and do not use passwords. They authenticate using API keys or access tokens which can be generated after creation.\n        "
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }